import React from "react";
import { FilterAccordian } from "./accordian/FilterAccordian";
import { i18n, _t } from "../../../app/i18n/i18n";
import filterCategories from "./filterCategories.json";

export const FilterPanel = ({ filter, aggregations = {} }) => {
  let categories = filterCategories.map((item) => {
    item.category = item["category_" + i18n.getLanguage()];
    const esKey = "es_category_" + i18n.getLanguage();
    item.aggregationsOptions = [_t("All"), ...(aggregations[item[esKey]] || [])];
    item.options = item.useAggs ? item.aggregationsOptions : item.options;
    if (item.exclusions) item.options = removeItems(item.options, item.exclusions);
    return item;
  });

  return (
    <section className="w-100 maxw-600 flex-grow-1 overflow-y-auto">
      {categories.map((item, key) => (
        <FilterAccordian key={key} {...item} filter={filter} options={item.options} />
      ))}
    </section>
  );
};

const removeItems = (arr, exclusions) => arr.filter((item) => !exclusions.includes(item));
